import { createSelector } from '@reduxjs/toolkit';

import { Resource } from 'src/containers/ProjectDiagram/types/data';
import { NodeData } from 'src/containers/ProjectDiagram/types/model';
import { isResource } from 'src/containers/ProjectDiagram/utils/data';
import { projectNodeDataArraySelector } from 'src/selectors/projectNodeDataArray';

export const projectNodeDataSelector = <T extends NodeData>(
  projectId: string,
  key: go.Key
) =>
  createSelector(
    projectNodeDataArraySelector(projectId),
    (nodeDataArray) =>
      nodeDataArray.find((existing): existing is T => existing.key === key) ||
      null
  );

export const projectResourceNodeDataArraySelector = (projectId: string) =>
  createSelector(projectNodeDataArraySelector(projectId), (nodeDataArray) =>
    nodeDataArray.filter<Resource>(isResource)
  );
